export const BAGGAGES = {
  BAGGAGE: 'BAGGAGE',
  CABIN_BAGGAGE: 'CABIN_BAGGAGE_PER_TRAVELER',
};
export const COUNTRY_CODES = {
  BR: 'BR',
  RU: 'RU',
};
